module.exports = __webpack_public_path__ + "static/media/volver.40360c0d.svg";